const NON_CPS_OFFLINE_DEPOSIT_LIST = [
  'Broker to Broker Transfer',
  'International Bank Transfer',
  'EURO SEPA',
  'Australia Bank Transfer',
  'Mongolia Bank Transfer',
  'PayID',
  'BPAY',
  'Local Currency PLN',
  'International Bank Transfer (Equals)',
  'International Bank Transfer (Spain)',
  'International Bank Transfer (FCA)',
]

const REDIRECT_BY_RESPONSE_MSG_DEPOSIT_LIST = ['iDEAL', 'Apple Pay', 'Google Pay']
export { NON_CPS_OFFLINE_DEPOSIT_LIST, REDIRECT_BY_RESPONSE_MSG_DEPOSIT_LIST }
